module.exports = __webpack_public_path__ + "static/media/stat547u_lecture02.6ce8c832.pdf";